import { combineReducers } from '@reduxjs/toolkit';

import { nameServices } from '../../common/services_reducers/nameServices';
import { typeServices } from '../../common/services_reducers/typeServices';

import { servicesAll } from './all/servicesAll';
import { servicesAllList } from './all/servicesAllList';

import { services } from './core/services';
import { servicesList } from './core/servicesList';

export default combineReducers({
    typeServices,
    nameServices,
    servicesAll,
    servicesAllList,
    services,
    servicesList,
});
